import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIconDisabled.svg'
import _imports_1 from '@/assets/filterIcon.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/deleteIcon.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 overflow-y-hidden" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Roles", -1)
const _hoisted_4 = { class: "cardbody" }
const _hoisted_5 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_6 = { class: "flex flex-row-reverse items-center" }
const _hoisted_7 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "my-3 text-xs" }, " Add new users, assign roles, update permissions, and remove access when needed. It’s the central place to manage who can do what in your app, making team collaboration secure and efficient. ", -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex items-center justify-between popup-header popupheadingcontainer rounded" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", null, "Roles", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "cursor-pointer"
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-col h-full popup-body" }
const _hoisted_17 = { class: "flex-1 overflow-auto" }
const _hoisted_18 = { class: "formcontainer px-4 pb-4 flex flex-col" }
const _hoisted_19 = { class: "row flex flex-row upperspacing" }
const _hoisted_20 = { class: "w-6/12" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "User mail id", -1)
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_24 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_25 = {
  key: 1,
  class: "invalid-feedback text-xs"
}
const _hoisted_26 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "This email already exists", -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "w-6/12 pl-4" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Username", -1)
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Charcter Limit is exceeded", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "flex h-full justify-between pt-4" }
const _hoisted_36 = { class: "w-1/2" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel mr-2 mb-2" }, "Status", -1)
const _hoisted_38 = { class: "switch" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "slider round" }, null, -1)
const _hoisted_41 = {
  key: 0,
  class: "w-1/2 flex items-center activeStyle"
}
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", {
  class: "font-extrabold text-xs cursor-pointer pl-2",
  for: "superUser"
}, "Super User", -1)
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 0,
  class: "flex items-center mt-4"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Roles")
], -1)
const _hoisted_47 = {
  key: 1,
  class: "border-b mt-1 border-solid border-lightgrey mt-2"
}
const _hoisted_48 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-sm" }, "At least one Tenent and Role is needed", -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "w-6/12 mr-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Tenant", -1)
const _hoisted_55 = ["onUpdate:modelValue"]
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  hidden: ""
}, "Please select a Tenant", -1)
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Required", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "w-6/12 mr-5" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "controllabel" }, "Role", -1)
const _hoisted_63 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", { class: "error-text" }, "At least one Role is needed", -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = ["onUpdate:modelValue", "disabled"]
const _hoisted_68 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  selected: "",
  hidden: ""
}, "Please select a role", -1)
const _hoisted_69 = ["value"]
const _hoisted_70 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "error-text text-xs" }, "Required", -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_74 = { class: "flex items-center pt-5" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "popup-footer" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)
const _hoisted_78 = {
  key: 0,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_79 = ["disabled"]
const _hoisted_80 = ["disabled"]
const _hoisted_81 = {
  key: 1,
  class: "flex items-center justify-end pb-4 pl-5 pt-4 pr-5"
}
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass(["flex items-center", _ctx.usersArray.length == 0?'btndisabled pointer-events-none':'filterButton']),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
            }, [
              (_ctx.usersArray.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                : (_openBlock(), _createElementBlock("img", _hoisted_8)),
              _createTextVNode(" Filters ")
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              class: "btnprimary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPopUp()))
            }, "Add")
          ])
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", null, [
      _createVNode(_component_newTable, {
        tableRowData: _ctx.usersArray,
        headersData: _ctx.headers,
        tableProps: _ctx.tableProps,
        openPopup: false,
        navigate: true,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "tableProps", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showAddPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showAddPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _hoisted_15)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.userObj.userMailId.$error|| _ctx.emailExists}]),
                        placeholder: "user@example.com",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userObj.userMailId) = $event)),
                        disabled: _ctx.editPopup==true||!_ctx.userObj.isActive,
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleEmailInput()))
                      }, null, 42, _hoisted_22), [
                        [
                          _vModelText,
                          _ctx.userObj.userMailId,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.userObj.userMailId.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            (_ctx.v$.userObj.userMailId.required.$invalid)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Required"))
                              : (_ctx.v$.userObj.userMailId.required&& _ctx.v$.userObj.userMailId.emailValidation)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Email is Invalid"))
                                : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.emailExists)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _withDirectives(_createElementVNode("input", {
                        class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.userObj.userName.$error}]),
                        placeholder: "Username",
                        disabled: !_ctx.userObj.isActive,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userObj.userName) = $event)),
                        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.userObj.userName.$touch()))
                      }, null, 42, _hoisted_31), [
                        [
                          _vModelText,
                          _ctx.userObj.userName,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (_ctx.v$.userObj.userName.restrictCharacters20.$invalid)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("label", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userObj.isActive) = $event)),
                          disabled: _ctx.userObj.userMailId == 'ranjith@crystallinesoft.com' && _ctx.userObj.superUser==true
                        }, null, 8, _hoisted_39), [
                          [_vModelCheckbox, _ctx.userObj.isActive]
                        ]),
                        _hoisted_40
                      ])
                    ]),
                    (_ctx.userObj.isActive)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: "superUser",
                            class: "checkbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userObj.superUser) = $event)),
                            disabled: _ctx.userObj.userMailId == 'ranjith@crystallinesoft.com' && _ctx.userObj.superUser==true
                          }, null, 8, _hoisted_42), [
                            [_vModelCheckbox, _ctx.userObj.superUser]
                          ]),
                          _hoisted_43
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.userObj.superUser==false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                        (_ctx.userObj.isActive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("div", null, [
                                _createElementVNode("button", {
                                  class: _normalizeClass(!_ctx.userObj.isActive ? 'btndisabled' : 'btnprimary'),
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addRoleActions()))
                                }, "Add", 2)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.userObj.isActive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                          : _createCommentVNode("", true),
                        (_ctx.usersRoleTenent?.length == 0 && _ctx.userObj.isActive)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                          : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                              (_ctx.userObj.isActive)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersRoleTenent, (obj, index) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "flex mt-4",
                                        key: obj
                                      }, [
                                        _createElementVNode("div", _hoisted_53, [
                                          _hoisted_54,
                                          _createElementVNode("div", null, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": ($event: any) => ((obj.tenant) = $event),
                                              class: _normalizeClass({
                                    'inputboxstylingForSelectAtPopup': obj.tenant === '',
                                    'stylingForInputboxstylingForSelectAtPopup': obj.tenant !== '',
                                    'is-invalid borderRed': _ctx.v$.usersRoleTenent.$dirty &&!_ctx.v$.usersRoleTenent.$each.$response.$data[index].tenant.required,
                                })
                                            }, [
                                              _hoisted_56,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterTenantOptions(index), (option) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  class: "optionColors",
                                                  key: option.value,
                                                  value: option.value
                                                }, _toDisplayString(option.label), 9, _hoisted_57))
                                              }), 128))
                                            ], 10, _hoisted_55), [
                                              [_vModelSelect, obj.tenant]
                                            ]),
                                            (_ctx.v$.usersRoleTenent.$dirty && !_ctx.v$.usersRoleTenent.$each.$response.$data[index].tenant.required)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                          _hoisted_62,
                                          (obj.length == 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, _hoisted_65))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_66, [
                                                _withDirectives(_createElementVNode("select", {
                                                  "onUpdate:modelValue": ($event: any) => ((obj.role) = $event),
                                                  disabled: obj.tenant==''||!_ctx.userObj.isActive,
                                                  class: _normalizeClass({
                                'inputboxstylingForSelectAtPopup': obj.role === '',
                                'stylingForInputboxstylingForSelectAtPopup': obj.role !== '',
                                'is-invalid borderRed': _ctx.v$.usersRoleTenent.$dirty &&!_ctx.v$.usersRoleTenent.$each.$response.$data[index].role.required,
                            })
                                                }, [
                                                  _hoisted_68,
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleOptions, (option) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                      class: "optionColors",
                                                      key: option.id,
                                                      value: option.id
                                                    }, _toDisplayString(option.value), 9, _hoisted_69))
                                                  }), 128))
                                                ], 10, _hoisted_67), [
                                                  [_vModelSelect, obj.role]
                                                ]),
                                                (_ctx.v$.usersRoleTenent.$dirty && !_ctx.v$.usersRoleTenent.$each.$response.$data[index].role.required)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, _hoisted_72))
                                                  : _createCommentVNode("", true)
                                              ])),
                                          _hoisted_73
                                        ]),
                                        _createElementVNode("div", _hoisted_74, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("img", {
                                              src: _imports_3,
                                              class: "cursor-pointer",
                                              onClick: ($event: any) => (_ctx.clickedOnDeleteButton(index))
                                            }, null, 8, _hoisted_75)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                (_ctx.editPopup==false)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("button", {
                        class: _normalizeClass([(JSON.stringify(_ctx.dummyUserObj) == JSON.stringify(_ctx.userObj) && JSON.stringify(_ctx.dummyRoleTenentObj) == JSON.stringify(_ctx.usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary', "btnprimary mr-2"]),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onCancelbtn()))
                      }, " Reset ", 10, _hoisted_79),
                      _createElementVNode("button", {
                        class: _normalizeClass((JSON.stringify(_ctx.dummyUserObj) == JSON.stringify(_ctx.userObj) && JSON.stringify(_ctx.dummyRoleTenentObj) == JSON.stringify(_ctx.usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSavebtn()))
                      }, " Save ", 10, _hoisted_80)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editPopup==true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _createElementVNode("button", {
                        class: _normalizeClass([(JSON.stringify(_ctx.dummyUserObj) == JSON.stringify(_ctx.userObj) && JSON.stringify(_ctx.dummyRoleTenentObj) == JSON.stringify(_ctx.usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary', "btnprimary mr-2"]),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onCancelbtn()))
                      }, " Reset ", 10, _hoisted_82),
                      _createElementVNode("button", {
                        class: _normalizeClass((JSON.stringify(_ctx.dummyUserObj) == JSON.stringify(_ctx.userObj) && JSON.stringify(_ctx.dummyRoleTenentObj) == JSON.stringify(_ctx.usersRoleTenent)) ? 'btndisabled pointer-events-none ' : 'btnprimary'),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onUpdatebtn()))
                      }, " Save ", 10, _hoisted_83)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}